import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import { ACCESS_TYPE } from './constants/static';
import lkeComponent from 'lke-component';
Vue.use(lkeComponent);
Vue.prototype.moment = moment;



let webIMType = [5];
let webIMSource = 'client';
window.$initTypeKey = 5;
Vue.prototype.webIMSource = webIMSource;

Object.defineProperty(window, 'userType', {
    writable: false,
    enumerable: false,
    configurable: false,
    value: 2
});
console.log('aiUtils ACCESS_TYPE >>:: ', ACCESS_TYPE);
let tokenGet = webIMType.map((type) => {
    /* eslint-disable no-async-promise-executor */
    return new Promise(async (resolve,) => {
        let demoToken = '';
        if (ACCESS_TYPE === 'ws') {
            const res = await axios.get('http://localhost:3000/getDemoToken');
            if (res && res.data && res.data.apiResponse && res.data.apiResponse.Token) {
                demoToken = res.data.apiResponse.Token;
            }
        }
        let result = {
            type: type,
            token: demoToken,
            access: ACCESS_TYPE
        };
        console.log('【init msg----------demoToken---->】', result);
        resolve(result);
    });
});
Promise.all(tokenGet).then(res => {
    Object.defineProperty(window, 'webimToken', {
        writable: false,
        enumerable: false,
        configurable: false,
        value: res
    });
    console.log("window.webimTp >>::", window.webimToken)
}).catch(e => {
    console.log("e >>::", e)
});
